import { AVATAR_PALETTE } from './constants';

export const getInitials = (name: string): string =>
  name
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

export const getAvatarColors = (name: string): Landing.AvatarColors => {
  const sum = Array.from(name).reduce(
    (runningSum, character) => runningSum + character.charCodeAt(0),
    0,
  );
  return AVATAR_PALETTE[sum % AVATAR_PALETTE.length];
};

const STAR = '★';
const MAX_STARS = 5;
const HANDLE_PREFIX = '@';

export const buildHandle = (displayName: string): string => {
  const first = displayName.split(/\s+/)[0] ?? 'pro';
  return `${HANDLE_PREFIX}${first.toLowerCase()}`;
};

export const stars = (count: number): string =>
  STAR.repeat(Math.max(0, Math.min(MAX_STARS, count)));
